import React, { Component } from 'react'
import { connect } from 'react-redux'
import { getTranslation } from '@/store/getters'
import { updateActualElement, setActiveElement, showFileManager, setLockBackground } from '@/store/actions'

import styles from './styles.scss'

/** Components */
import IconComponent from '@/components/commons/IconComponent'
import Opacity from '@/components/Opacity'
import UploadImage from '@/components/UploadImage'
import Border from '@/components/editors/Border'
import BoxShadow from '@/components/editors/BoxShadow'
import BorderRadius from '@/components/editors/BorderRadius'
import InputNumber from '@/components/InputNumber/index'
import FontLink from '@/components/editors/FontLink'

class IframeContent extends Component {

  save = element => {
    const { id, id_page: pageID } = element
    const { updateActualElement, user: { accessToken } } = this.props

    updateActualElement({
      id,
      pageID,
      element,
      accessToken
    })
  }

  handleStyles = style => {
    const { element } = this.props

    element.content.styles = {
      ...element.content.styles,
      ...style
    }
    this.save(element)
  }

  handleContent = content => {
    const { element } = this.props

    element.content.content = {
      ...element.content.content,
      ...content
    }

    this.save(element)
  }

  handleAlternativeText = text => {
    const { element } = this.props

    element.content.text = text
    this.save(element)
  }

  handleImageSended = src => {
    const { element } = this.props

    element.content.attributes = {
      ...element.content.attributes,
      src
    }

    this.save(element)
  }

  handleBorder = ({ type, size, color }) => this.handleStyles({
    borderStyle: type,
    borderWidth: `${size}px`,
    borderColor: color
  })

  handleShadow = shadow => this.handleStyles({
    boxShadow: `${shadow.x}px ${shadow.y}px ${shadow.blur}px ${shadow.color}`
  })

  handleLink = link => {
    const { element } = this.props
    element.content.link = link
    this.save(element)
  }

  render() {
    const { translation, element } = this.props

    const {
      width,
      height,
      opacity,
      borderWidth,
      borderStyle,
      borderColor,
      boxShadow,
      borderTopLeftRadius,
      borderTopRightRadius,
      borderBottomLeftRadius,
      borderBottomRightRadius,
    } = element.content.styles

    const { src } = element.content.attributes
    const { link, text } = element.content

    return (
      <div className={'ba-pd-r-1 ba-pd-b-2'}>

        <hr className={'ba-hr'} />
        <p className={'ba-mg-t-1 ba-font'}>{translation('general-alternative-text')}</p >
        <input
          type='text' className='ba-input ba-w-100'
          placeholder={translation('general-text')}
          value={text}
          onChange={({ target }) => this.handleAlternativeText(target.value)}
        />

        <hr className={'ba-mg-y-1 ba-hr'} />


        <p className={'ba-mg-t-1 ba-font'}>{translation('general-image-url')}</p >
        <input
          type='text' className='ba-input ba-w-100'
          value={src}
          placeholder='https://images.unsplash.com/photo-1547692098-b139f1ea4cbf'
          onChange={({ target }) => this.handleImageSended(target.value)}
        />
        <hr className={'ba-mg-y-1 ba-hr'} />


        <p className={'ba-mg-t-1 ba-font'}>{translation('general-image-upload')}</p >

        <UploadImage onImageSended={this.handleImageSended} />

        <hr className={'ba-mg-y-1 ba-hr'} />

        <p className={'ba-mg-t-1 ba-font'}>{translation('general-specify-size')}</p >
        <div className={styles['wrapper-specify-size']}>
          <div className={'ba-flex ba-ai-center ' + styles['vertical-icon']}>
            <InputNumber
              value={parseInt(height, 10)}
              onChange={({ target }) => this.handleStyles({ height: `${target.value}px` })}
            />
            <IconComponent icon='vertical-arrow' />
          </div>
          <div className={'ba-flex ba-ai-center ' + styles['horizontal-icon']}>
            <IconComponent icon='horizontal-arrow' />
            <InputNumber
              value={parseInt(width, 10)}
              onChange={({ target }) => this.handleStyles({ width: `${target.value}px` })}
            />
          </div>
        </div>

        <hr className={'ba-mg-y-1 ba-hr'} />


        <p className={'ba-mg-t-1 ba-font'}>{translation('general-border')}</p >
        <Border
          type={borderStyle}
          size={borderWidth}
          color={borderColor}
          onChange={this.handleBorder}
        />

        <hr className={'ba-mg-y-1 ba-hr'} />


        <p className={'ba-font'}>{translation('general-shadow')}</p>
        <BoxShadow
          shadow={boxShadow}
          onChange={this.handleShadow}
        />

        <hr className={'ba-mg-y-1 ba-hr'} />


        <p className={'ba-font'}>{translation('general-transparency')}</p>
        <Opacity
          opacity={opacity}
          onChange={value => this.handleStyles({ opacity: value })}
        />

        <hr className={'ba-mg-y-1 ba-hr'} />


        <p className={'ba-font'}>{translation('general-border')}</p>
        <BorderRadius
          topLeft={borderTopLeftRadius}
          topRight={borderTopRightRadius}
          bottomLeft={borderBottomLeftRadius}
          bottomRight={borderBottomRightRadius}
          onChange={this.handleStyles}
        />

        <hr className={'ba-mg-y-1 ba-hr'} />


        <FontLink link={link} onChangeLink={this.handleLink} />
      </div>
    )
  }
}

const mapStateProps = state => {
  const translation = getTranslation(state)
  return { translation }
}

export default connect(mapStateProps,
  {
    updateActualElement,
    setActiveElement, showFileManager, setLockBackground
  }
)(IframeContent)


// WEBPACK FOOTER //
// ./src/pages/Editor/components/ContentEditor/editors/ImageContent/index.js